import React from 'react'

interface Props {
  text: string
  url: string
}

const MarketplaceLink = ({text, url}: Props): JSX.Element => {
  return (
    <a href={url} target="_blank">
      {text}
    </a>
  )
}

export default MarketplaceLink
